<template>
	<div class="config page-container custom-scroll-bar">
		<div class="block">
			<div class="block-title">
				企业简介
			</div>
			<div class="block-area">
				<div class="block-image">
					<div class="block-key">
						上传图片
					</div>
					<div class="block-value">
						<el-upload class="image-uploader" :action="uploadFileUrl" :show-file-list="false"
							:on-success="handleImageSuccess" :before-upload="beforeImageUpload"
							:on-progress="onImageUpload" :headers="{Authtoken:token}" accept="image/*">
							<img v-if="imageUrl" :src="$pub.imageUrl+imageUrl" class="image">
							<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						</el-upload>
					</div>
				</div>
				<div class="block-text-area">
					<div class="block-key">
						编辑简介
					</div>
					<div class="block-value">
						<Tinymce v-if="richTextFlag" v-model="richText" placeholder="请编辑简介内容..." :height="400"></Tinymce>
					</div>
				</div>
				<div class="block-button">
					<el-button type="primary" @click="saveDescription">保存简介</el-button>
				</div>
			</div>
		</div>
		<div class="block">
			<div class="block-title">
				联系我们
			</div>
			<div class="block-area">
				<!-- <div class="block-line">
					<div class="block-key">
						GPS坐标：
					</div>
					<div class="block-value">
						<div class="block-input">
							经度（lng）：<el-input type="number" placeholder="请输入经度（longitude）" v-model="lng"></el-input>
							纬度（lat）：<el-input type="number" placeholder="请输入纬度（latitude）" v-model="lat"></el-input>
						</div>
					</div>
				</div> -->
				<div class="block-line">
					<div class="block-key">
						公司地址：
					</div>
					<div class="block-value">
						<div class="block-position" v-for="(item,index) in addressList" :key="index">
							<div class="block-position-input">
								<div class="block-position-line">
									分部名称：<el-input type="text" placeholder="请输入分部名称" v-model="item.name"></el-input>
									分部地址：<el-input type="text" placeholder="请输入分部地址" v-model="item.address"></el-input>
								</div>
								<div class="block-position-line">
									经度（lng）：<el-input type="number" placeholder="请输入经度（longitude）" v-model="item.lng">
									</el-input>
									纬度（lat）：<el-input type="number" placeholder="请输入纬度（latitude）" v-model="item.lat">
									</el-input>
								</div>
							</div>
							<div class="block-position-minus">
								<el-button type="danger" plain circle size="mini" @click="removeAddress(index)"
									icon="el-icon-close" v-if="index>0">
								</el-button>
							</div>
						</div>
						<div class="block-plus">
							<el-button type="primary" icon="el-icon-plus" plain size="mini" @click="addAddress">增加分部地址
							</el-button>
						</div>
					</div>
				</div>
				<div class="block-line">
					<div class="block-key">
						交通路线：
					</div>
					<div class="block-value">
						<div class="block-address" v-for="(item,index) in addressList" :key="index">
							<div class="block-point">
								{{item.name}}:
							</div>
							<div class="block-traffic">
								<div class="block-traffic-item" v-for="(tab,tabIndex) in item['tabs']" :key="tabIndex">
									<el-input type="text" placeholder="请输入交通方式" v-model="item['tabs'][tabIndex]">
									</el-input>
									<el-button type="danger" plain circle size="mini"
										@click="removeTraffic(index,tabIndex)" icon="el-icon-close" v-if="tabIndex>0">
									</el-button>
								</div>
							</div>
							<div class="block-plus">
								<el-button type="primary" icon="el-icon-plus" plain size="mini"
									@click="addTraffic(index)">
									增加交通方式
								</el-button>
							</div>
						</div>
					</div>
				</div>
				<div class="block-line">
					<div class="block-key">
						联系方式：
					</div>
					<div class="block-value">
						<div class="block-input" v-for="(item,index) in contact" :key="index">
							联系方式名称：<el-input type="text" placeholer="请输入联系方式名称" v-model="item.name"></el-input>
							联系方式值：<el-input type="text" placeholder="请输入联系方式值" v-model="item.value"></el-input>
							<el-button type="danger" plain circle size="mini" @click="removeContact(index)"
								icon="el-icon-close" v-if="index>0"></el-button>
						</div>
						<div class="block-plus">
							<el-button type="primary" icon="el-icon-plus" plain size="mini" @click="addContact">增加联系方式
							</el-button>
						</div>
					</div>
				</div>
				<div class="block-button">
					<el-button type="primary" @click="saveContact">保存联系方式</el-button>
				</div>
			</div>
		</div>
		<div class="block">
			<div class="block-title">
				版权信息
			</div>
			<div class="block-area">
				<div class="block-line">
					<div class="block-key">公司名称：</div>
					<div class="block-value">
						<div class="block-input">
							<el-input type="text" placeholder="请输入公司名称" v-model="company_name"></el-input>
							<el-input type="text" placeholder="请输入公司英文名称" v-model="company_name_en"></el-input>
						</div>
					</div>
				</div>
				<div class="block-line">
					<div class="block-key">增值电信业务经营许可证：</div>
					<div class="block-value">
						<div class="block-input">
							<el-input type="text" placeholder="请输入许可证号" v-model="zzdxywjyxkz"></el-input>
						</div>
					</div>
				</div>
				<!-- <div class="block-line">
					<div class="block-key">增值电信业务经营许可证（跨地区）：</div>
					<div class="block-value">
						<div class="block-input">
							<el-input type="text" placeholder="请输入许可证号（跨地区）" v-model="zzdxywjyxkz_kdq"></el-input>
						</div>
					</div>
				</div> -->
				<div class="block-line">
					<div class="block-key">京网文：</div>
					<div class="block-value">
						<div class="block-input">
							<el-input type="text" placeholder="请输入京网文号" v-model="jww"></el-input>
						</div>
					</div>
				</div>
				<div class="block-line">
					<div class="block-key">京网公安备案：</div>
					<div class="block-value">
						<div class="block-input">
							<el-input type="text" placeholder="请输入京网公安备案号" v-model="jwgaba"></el-input>
						</div>
					</div>
				</div>
				<div class="block-line">
					<div class="block-key">京ICP备案：</div>
					<div class="block-value">
						<div class="block-input">
							<el-input type="text" placeholder="请输入ICP备案号" v-model="j_icp"></el-input>
						</div>
					</div>
				</div>
				<div class="block-line">
					<div class="block-key">版权时间：</div>
					<div class="block-value">
						<div class="block-input">
							<el-input type="text" placeholder="请输入版权时间" v-model="copyright_time"></el-input>
						</div>
					</div>
				</div>
				<div class="block-line">
					<div class="block-key">网站名称：</div>
					<div class="block-value">
						<div class="block-input">
							<el-input type="text" placeholder="请输入网站名称" v-model="web_name"></el-input>
						</div>
					</div>
				</div>
				<div class="block-image">
					<div class="block-key">
						公众号二维码：
					</div>
					<div class="block-value">
						<el-upload class="qrcode-uploader" :action="uploadFileUrl" :show-file-list="false"
							:on-success="handleQRCodeSuccess" :before-upload="beforeQRCodeUpload"
							:on-progress="onQRCodeUpload" :headers="{Authtoken:token}" accept="image/*">
							<img v-if="qrcodeUrl" :src="$pub.imageUrl+qrcodeUrl" class="qrcode">
							<i v-else class="el-icon-plus qrcode-uploader-icon"></i>
						</el-upload>
					</div>
				</div>
				<div class="block-button">
					<el-button type="primary" @click="saveCopyright">保存网站信息</el-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Tinymce from '@/components/Tinymce'
	export default {
		name: 'config',
		components: {
			Tinymce
		},
		data() {
			return {
				uploadFileUrl: '',
				imageUrl: '',
				richText: '',
				qrcodeUrl: '',
				addressList: [{
					name: '',
					address: '',
					lng: '',
					lat: '',
					tabs: [
						''
					]
				}],
				contact: [{
					name: '',
					value: ''
				}],
				company_name: '',
				company_name_en: '',
				zzdxywjyxkz: '',
				// zzdxywjyxkz_kdq: '',
				jww: '',
				jwgaba: '',
				j_icp: '',
				copyright_time: '',
				web_name: '',
				richTextFlag: false
			};
		},
		methods: {
			// 关于我们图片上传相关
			handleImageSuccess(res) {
				if (res.code == 200) {
					this.imageUrl = res.data.fileUrl
				}
			},
			beforeImageUpload(file) {
				const isLt10M = file.size / 1024 / 1024 < 10;
				if (!isLt10M) {
					this.$message.error('上传图片大小不能超过 10MB!');
				}
				return isLt10M;
			},
			onImageUpload(file) {
				console.log(file);
			},
			// 保存简介
			saveDescription() {
				this.$api.webConfigSave({
					comImg: this.imageUrl,
					comIntroduce: this.richText
				}, res => {
					if (res.code == 200) {
						this.$message({
							message: '简介保存成功。',
							type: 'success',
							duration: 2000
						})
					}
				})
			},
			// 移除地址
			removeAddress(index) {
				this.addressList.splice(index, 1)
			},
			// 添加地址
			addAddress() {
				this.addressList.push({
					name: '',
					address: '',
					lng: '',
					lat: '',
					tabs: [
						''
					]
				})
			},
			// 移除交通方式
			removeTraffic(index, tabIndex) {
				this.addressList[index].tabs.splice(tabIndex, 1)
			},
			// 添加交通方式
			addTraffic(index, tabIndex) {
				this.addressList[index].tabs.push('')
			},
			// 移除联系方式
			removeContact(index) {
				this.contact.splice(index, 1)
			},
			// 增加联系方式
			addContact() {
				this.contact.push({
					name: '',
					value: ''
				})
			},
			// 保存联系方式
			saveContact() {
				this.$api.webConfigSave({
					addressTraffic: JSON.stringify(this.addressList),
					contact: JSON.stringify(this.contact)
				}, res => {
					if (res.code == 200) {
						this.$message({
							message: '地址与联系方式保存成功。',
							type: 'success',
							duration: 2000
						})
					}
				})
			},
			// 保存版权信息
			saveCopyright() {
				this.$api.webConfigSave({
					comName: this.company_name,
					comNameEn: this.company_name_en,
					comLicense: this.zzdxywjyxkz,
					// comLicenseRegion: this.zzdxywjyxkz_kdq,
					comArticle: this.jww,
					comRecordSecurity: this.jwgaba,
					comIcp: this.j_icp,
					copyrightAt: this.copyright_time,
					webName: this.web_name,
					erCodeUrl: this.qrcodeUrl
				}, res => {
					if (res.code == 200) {
						this.$message({
							message: '版权信息保存成功',
							type: 'success',
							duration: 2000
						})
					}
				})
			},
			// 二维码图片上传相关
			handleQRCodeSuccess(res) {
				if (res.code == 200) {
					this.qrcodeUrl = res.data.fileUrl
				}
			},
			beforeQRCodeUpload(file) {
				const isLt10M = file.size / 1024 / 1024 < 10;
				if (!isLt10M) {
					this.$message.error('上传图片大小不能超过 10MB!');
				}
				return isLt10M;
			},
			onQRCodeUpload(file) {
				console.log(file);
			},
			fetchData() {
				this.$api.webConfigDetail({}, res => {
					if (res.code == 200) {
						this.imageUrl = res.data.comImg == null ? '' : res.data.comImg
						this.richText = res.data.comIntroduce == null ? '' : res.data.comIntroduce
						this.richTextFlag = true
						this.addressList = res.data.addressTraffic == null ? [{
							name: '示例名称',
							address: '示例地址',
							lng: '116.32176865551756',
							lat: '39.89466781015002',
							tabs: [
								'示例地址'
							]
						}] : JSON.parse(res.data.addressTraffic)
						this.contact = res.data.contact == null ? [{
							name: '',
							value: ''
						}] : JSON.parse(res.data.contact)
						this.company_name = res.data.comName == null ? '' : res.data.comName
						this.company_name_en = res.data.comNameEn == null ? '' : res.data.comNameEn
						this.zzdxywjyxkz = res.data.comLicense == null ? '' : res.data.comLicense
						this.zzdxywjyxkz_kdq = res.data.comLicenseRegion == null ? '' : res.data.comLicenseRegion
						this.jww = res.data.comArticle == null ? '' : res.data.comArticle
						this.jwgaba = res.data.comRecordSecurity == null ? '' : res.data.comRecordSecurity
						this.j_icp = res.data.comIcp == null ? '' : res.data.comIcp
						this.copyright_time = res.data.copyrightAt == null ? '' : res.data.copyrightAt
						this.web_name = res.data.webName == null ? '' : res.data.webName
						this.qrcodeUrl = res.data.erCodeUrl == null ? '' : res.data.erCodeUrl
					}
				})
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
			this.uploadFileUrl = this.$pub.requestUrl + 'uploadImg'
			this.token = this.$pub.getStorage('adm_token')
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			this.fetchData()
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	};
</script>

<style lang="less" scoped="scoped">
	.config {
		overflow-y: auto;
		padding: @vue-spacing-col-base @vue-spacing-row-base;
		box-sizing: border-box;
	}

	.qrcode-uploader {
		margin-left: @vue-spacing-row-base;
	}

	.image-uploader .el-upload {
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.image-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		border: 1px dashed #d9d9d9;
		font-size: 28px;
		color: #8c939d;
		width: 376px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	.qrcode-uploader-icon {
		border: 1px dashed #d9d9d9;
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	.image {
		width: 376px;
		height: 178px;
		display: block;
	}

	.qrcode {
		width: 178px;
		height: 178px;
		display: block;
	}

	.block {
		width: 100%;
		margin-bottom: @vue-spacing-col-base;

		.block-title {
			width: 100%;
			height: 50px;
			background: @vue-bg-color-grey;
			display: flex;
			align-items: center;
			font-size: @vue-font-size-sm + 2;
			font-weight: bold;
			padding-left: @vue-spacing-row-sm;
			box-sizing: border-box;
		}

		.block-area {
			width: 100%;
			margin-top: @vue-spacing-col-base;
		}

		.block-image,
		.block-line {
			width: 100%;
			display: flex;
			padding-left: @vue-spacing-row-sm;
			box-sizing: border-box;
			margin-bottom: @vue-spacing-col-base;

			.block-key {
				width: 130px;
				height: 60px;
				display: flex;
				align-items: center;
				font-size: @vue-font-size-sm - 2;
			}
		}

		.block-text-area {
			width: 100%;
			padding-left: @vue-spacing-row-sm;
			box-sizing: border-box;
			margin-bottom: @vue-spacing-col-base;

			.block-key {
				width: 100%;
				height: 60px;
				display: flex;
				align-items: center;
			}
		}

		.block-line {
			.block-value {
				width: calc(100% - 130px);
			}

			.block-input {
				width: 100%;
				height: 60px;
				display: flex;
				align-items: center;
				flex-wrap: wrap;

				.el-input {
					width: 350px;
					margin: 0px @vue-spacing-row-base;
				}
			}

			.block-position {
				width: 100%;
				height: 120px;
				border: 2px solid #ffd0d1;
				display: flex;
				margin-bottom: @vue-spacing-col-base;
				border-radius: @vue-border-radius-lg;
				padding-left: @vue-spacing-row-base;
				box-sizing: border-box;

				.block-position-line {
					width: 100%;
					height: 60px;
					display: flex;
					align-items: center;
				}

				.el-input {
					width: 350px;
					margin: 0px @vue-spacing-row-base;
				}

				.block-position-minus {
					height: 100%;
					display: flex;
					align-items: center;
				}
			}



			.block-address {
				width: 100%;
				display: flex;
				flex-wrap: wrap;

				.block-point {
					width: 150px;
					height: 60px;
					display: flex;
					align-items: center;
				}

				.block-traffic {
					width: 500px;

					.block-traffic-item {
						width: 100%;
						height: 60px;
						display: flex;
						align-items: center;

						.el-input {
							width: 350px;
							margin-right: @vue-spacing-row-base;
						}
					}
				}

				.block-plus {
					padding-left: 150px;
					box-sizing: border-box;
				}
			}

			.block-plus {
				width: 100%;
				padding: @vue-spacing-col-sm 0px;
			}
		}

		.block-button {
			width: 100%;
			padding-left: @vue-spacing-row-sm;
			box-sizing: border-box;

			.el-button {
				width: 150px;
			}
		}
	}
</style>
